import { m8API } from 'services/production/m8';
import { ClientPartnerBindingDeletionService } from 'types/services';

export const deleteClientPartnerBinding: ClientPartnerBindingDeletionService = async (
  params
) => {
  const { clientId } = params;

  await m8API.admin.dropUserPartner({ idUser: clientId });
};
